<template>
  <div>
    <bread-crumb></bread-crumb>
    <dataForm :searchList.sync="searchList" @onSubmit="onSubmit" />
    <liveTable ref="liveTableRef" :searchList="searchList" />
  </div>
</template>

<script>
import dataForm from "./components/dataForm";
import breadCrumb from "@/components/breadCrumb";
import liveTable from './components/liveTable';

export default {
  name: "medicalCenter",
  data() {
    return {
      searchList: {
        externalId: '',
        publisher: '',
        contentName: '',
        liveTime: [],
        liveStartTimeGte: '',
        liveStartTimeLte	: '',
        liveStatus: '',
        liveMark: '',
      },  // 表单数据
    }
  },
  components: {
    dataForm,
    breadCrumb,
    liveTable,
  },
  methods: {
    onSubmit() {
      this.$refs.liveTableRef.updateTableList()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../styles/element.scss';

</style>
